import { render, staticRenderFns } from "./SelectLanguageModal.vue?vue&type=template&id=6260cae3"
import script from "./SelectLanguageModal.vue?vue&type=script&lang=js"
export * from "./SelectLanguageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports